var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CreditCardOutlineIcon, DocumentOutlineIcon, FilledArrowUpRightIcon, UsersOutlineIcon, WritingPenOutlineIcon, } from '@rappi/rests-commons-front';
import { commercialProcessesService, } from '../services/commercial-processes.service';
import { wait } from '../utils/wait';
export const COMMERCIAL_PROCESSES_CONFIG = {
    'bank-account-change': {
        title: 'commercialProcessesFinder.processes.bank-account-change.title',
        description: 'commercialProcessesFinder.processes.bank-account-change.description',
        duration: 20,
        icon: CreditCardOutlineIcon,
        action: (type, data, context, contextId) => __awaiter(void 0, void 0, void 0, function* () {
            const { bankInformationFormData, bankAccountSelected, files } = data;
            const fileIds = Object.values(files || {})
                .map((file) => file === null || file === void 0 ? void 0 : file.id)
                .filter((id) => id !== undefined);
            const payload = {
                account: {
                    number: (bankInformationFormData === null || bankInformationFormData === void 0 ? void 0 : bankInformationFormData.accountNumber) || '',
                    accountType: (bankInformationFormData === null || bankInformationFormData === void 0 ? void 0 : bankInformationFormData.accountType) || '',
                    holderName: (bankInformationFormData === null || bankInformationFormData === void 0 ? void 0 : bankInformationFormData.accountOwnerName) || '',
                    identification: (bankInformationFormData === null || bankInformationFormData === void 0 ? void 0 : bankInformationFormData.accountOwnerId) || '',
                    identificationType: (bankInformationFormData === null || bankInformationFormData === void 0 ? void 0 : bankInformationFormData.accountOwnerIdType) || '',
                    bankID: parseInt((bankInformationFormData === null || bankInformationFormData === void 0 ? void 0 : bankInformationFormData.bankingEntity) || '0'),
                    details: [],
                },
                paymentReference: `${context.country}${(bankAccountSelected === null || bankAccountSelected === void 0 ? void 0 : bankAccountSelected.id.toString()) || ''}`,
                files: fileIds,
            };
            if (type === 'update') {
                if (!contextId) {
                    throw new Error('Commercial process context id not found');
                }
                const params = {
                    commercialProcessContextId: contextId,
                    body: payload,
                };
                yield commercialProcessesService.updateCommercialProcess(params);
                return;
            }
            const params = {
                commercialProcessId: 'bank-account-change',
                businessId: `${context.country}${context.business.id}`,
                body: payload,
            };
            yield commercialProcessesService.startCommercialProcess(params);
        }),
    },
    'social-reason-change': {
        title: 'commercialProcessesFinder.processes.social-reason-change.title',
        description: 'commercialProcessesFinder.processes.social-reason-change.description',
        duration: 30,
        icon: FilledArrowUpRightIcon,
        action: (type, data, context, contextId) => __awaiter(void 0, void 0, void 0, function* () {
            yield wait(1000);
            console.log('social-reason-change', { type, data, context, contextId });
        }),
    },
    'fiscal-information-change': {
        title: 'commercialProcessesFinder.processes.fiscal-information-change.title',
        description: 'commercialProcessesFinder.processes.fiscal-information-change.description',
        duration: 30,
        icon: DocumentOutlineIcon,
        action: (type, data, context, contextId) => __awaiter(void 0, void 0, void 0, function* () {
            yield wait(1000);
            console.log('fiscal-information-change', { type, data, context, contextId });
        }),
    },
    'brand-name-change': {
        title: 'commercialProcessesFinder.processes.brand-name-change.title',
        description: 'commercialProcessesFinder.processes.brand-name-change.description',
        duration: 20,
        icon: WritingPenOutlineIcon,
        action: (type, data, context, contextId) => __awaiter(void 0, void 0, void 0, function* () {
            yield wait(1000);
            console.log('brand-name-change', { type, data, context, contextId });
        }),
    },
    'legal-representative-change': {
        title: 'commercialProcessesFinder.processes.legal-representative-change.title',
        description: 'commercialProcessesFinder.processes.legal-representative-change.description',
        duration: 30,
        icon: UsersOutlineIcon,
        action: (type, data, context, contextId) => __awaiter(void 0, void 0, void 0, function* () {
            yield wait(1000);
            console.log('legal-representative-change', { type, data, context, contextId });
        }),
    },
};
